import { get } from './helpers'
import { Product } from 'types/index'

export const getProducts = async (): Promise<Product[]> => {
  const products = await get<Product[]>(`/products`)

  return products
}
